import React from 'react';
import {
    SettingsSidebar as Sidebar,
    SidebarHeader,
    HeaderTitle,
    CloseButton,
    SidebarContent
} from '../../styles/ProjectSettingsMenu.styles';
import CloseIcon from '../icons/CloseIcon';

const SettingsSidebar = ({ activeSection, children, onClose, forwardedRef }) => (
    <Sidebar ref={forwardedRef}>
        <SidebarHeader>
            <HeaderTitle>
                {!activeSection ? 'Settings' :
                    activeSection === 'background' ? 'Change background' :
                        activeSection === 'members' ? 'Members' :
                            activeSection === 'archived' ? 'Archived Items' : ''}
            </HeaderTitle>
            <CloseButton
                onClick={onClose}
                title="Close settings"
            >
                <CloseIcon />
            </CloseButton>
        </SidebarHeader>
        <SidebarContent>
            {children}
        </SidebarContent>
    </Sidebar>
);

export default SettingsSidebar;